export const COLLAPSE_ANIMATION_DURATION = 0.2
export const COLLAPSE_ANIMATION_EASING = [0.04, 0.62, 0.23, 0.98] as const
export const COLLAPSE_ANIMATION_EASING_CSS = `cubic-bezier(${COLLAPSE_ANIMATION_EASING.join(', ')})`
